import {useCallback, useEffect, useMemo, useRef} from 'react';
import {BroadcastChannelWrapper, CLIENT_PROCESS_ID} from "./channels";

export const useApplicationEvents = (eventName) => {
  const channelRef = useRef(null);
  useEffect(() => {
    const channel = new BroadcastChannelWrapper(eventName);
    channelRef.current = channel;
    return () => {channel.close(); if (channelRef.current === channel) channelRef.current = null;};
  }, [eventName]);
  const postMessage = useCallback((msg) => {
    if (channelRef.current) {
      channelRef.current.postMessage({...msg, _timestamp: new Date().toISOString()});
    } else console.error(`BroadcastChannel for ${eventName} is closed`);
  }, [eventName]);

  return useMemo(() => ({postMessage}), [postMessage]);
};

export const useEventListener = (eventName, callback, deps = [], options = {}) => {
  const {filterSameProcess = false} = options;
  const channelRef = useRef(null);
  const callbackRef = useRef(callback); callbackRef.current = callback;
  
  useEffect(() => {
    const handler = (event) => {
      if (filterSameProcess && event.data.__processId === CLIENT_PROCESS_ID) return;
      callbackRef.current(event.data);
    };

    channelRef.current = new BroadcastChannelWrapper(eventName, handler);
    return () => { channelRef.current.close(); channelRef.current = null; };
  }, [eventName, filterSameProcess, ...deps]);
};

export const useOtherTabEventListener = (eventName, callback) => 
  useEventListener(eventName, callback, [], {filterSameProcess: true});
